export const educationList = [
  'Nido Integrato',
  "Scuola dell'infanzia",
  'Scuola primaria',
]
